<script lang="ts">
    import { apiBaseURL } from "../../config"

    import Aplayer from "svelte-aplayer/dist/svelte/svelte-aplayer.es.js"
    import "svelte-aplayer/dist/svelte/style.css"

    export let article: SWArticle = null
    export let block: ContentBlock = null
    export let id = null

    let url
    let files: AudioFile[]

    $: {
        if (article) {
            url = `${apiBaseURL}articles/${article?.id ? article?.id : id}/`
            files = article?.audioFiles
        } else if (block) {
            url = `${apiBaseURL}content/${id}/`
            files = block?.audioFiles
        }
    }
</script>

{#if files?.length}
    <section class="audio-files">
        {#each files as audioFile}
            {#if audioFile?.file?.src}
                <section class="row mb-lg">
                    <div class="col-md-7">
                        {#if audioFile.title}
                            <h4 class="mb-sm audio-file-title">
                                {audioFile.title}
                            </h4>
                        {/if}
                        {#if audioFile.description}
                            <div class="mb-sm audio-file-description">
                                {@html audioFile.description}
                            </div>
                        {/if}
                    </div>
                    <div class="col-md-5">
                        <!-- <Aplayer
                            audio="{{
                                name: audioFile.title,
                                artist: '',
                                cover: '',
                                url: `${url}${audioFile?.file?.src}`,
                            }}"
                        /> -->
                        <audio controls>
                            <source
                                src="{url}{audioFile?.file?.src}"
                                type="audio/mpeg"
                            />
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                </section>
            {/if}
        {/each}
    </section>
{/if}
